// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Persona_wrapper__2w7sg","title":"Persona_title___zRms"};